import pick from 'lodash/pick';

import * as TrackerEvents from '../config/tracker-events';

const trackerGenerator = {
  computed: {
    defaultPayload() {
      return {
        source: this.$root.source,
        referrer: this.$route?.query?.referrer || '',
        ui: window.USER.id36,
        session: this.$root.mixinSessionId,
        session_id: this.$root.mixinSessionId,
        page_name: this.$route.name,
        td_path: this.$route.path,
      };
    },
  },
  methods: {
    mixinSendTracker(eventName, additionalPayload = {}) {
      return this.$tracker.event(this[eventName](additionalPayload));
    },

    // don't call these methods, use `sendTracker` instead
    generator({trackerRequirementFields, additionalPayload} = {}, eventName) {
      return pick({...this.defaultPayload, ...additionalPayload, evn: eventName}, trackerRequirementFields);
    },
    [TrackerEvents.TRACKER_EVENT_VP_EDU_KARIER_BANNER_CLICK](additionalPayload) {
      const trackerRequirementFields = ['evn', 'source', 'referrer', 'ui', 'session_id', 'banner_name', 'banner_url', 'banner_position'];
      return this.generator({trackerRequirementFields, additionalPayload}, TrackerEvents.TRACKER_EVENT_VP_EDU_KARIER_BANNER_CLICK);
    },
    [TrackerEvents.TRACKER_EVENT_VP_EDU_KARIER_VISIT_PAGE_VIEW](additionalPayload) {
      const trackerRequirementFields = ['evn', 'source', 'referrer', 'ui', 'session_id', 'page_name', 'td_path'];
      return this.generator({trackerRequirementFields, additionalPayload}, TrackerEvents.TRACKER_EVENT_VP_EDU_KARIER_VISIT_PAGE_VIEW);
    },
    [TrackerEvents.TRACKER_EVENT_VP_EDU_KARIER_SECTION_CLICK](additionalPayload) {
      const trackerRequirementFields = [
        'evn',
        'source',
        'referrer',
        'ui',
        'session_id',
        'sku_id',
        'course_title',
        'lpk_name',
        'section_name',
      ];
      return this.generator({trackerRequirementFields, additionalPayload}, TrackerEvents.TRACKER_EVENT_VP_EDU_KARIER_SECTION_CLICK);
    },
    [TrackerEvents.TRACKER_EVENT_VP_EDU_KARIER_LEMBAGA_REGISTER_CLICK](additionalPayload) {
      const trackerRequirementFields = ['evn', 'source', 'referrer', 'ui', 'session_id', 'page_name'];
      return this.generator(
        {trackerRequirementFields, additionalPayload},
        TrackerEvents.TRACKER_EVENT_VP_EDU_KARIER_LEMBAGA_REGISTER_CLICK
      );
    },
    [TrackerEvents.TRACKER_EVENT_VP_EDU_KARIER_PDP_CLICK](additionalPayload) {
      const trackerRequirementFields = ['evn', 'source', 'referrer', 'ui', 'session_id', 'sku_id', 'action'];
      return this.generator({trackerRequirementFields, additionalPayload}, TrackerEvents.TRACKER_EVENT_VP_EDU_KARIER_PDP_CLICK);
    },
    [TrackerEvents.TRACKER_EVENT_VP_EDU_KARIER_SEARCH](additionalPayload) {
      const trackerRequirementFields = ['evn', 'source', 'referrer', 'ui', 'session_id', 'filter_value'];
      return this.generator({trackerRequirementFields, additionalPayload}, TrackerEvents.TRACKER_EVENT_VP_EDU_KARIER_SEARCH);
    },
  },
};

export default trackerGenerator;
